/**
 * Web Vitals collector — sends CLS, LCP, INP metrics to GA4.
 * Uses the `web-vitals` library already bundled in CRA.
 */
import { getCLS, getLCP, getFID } from 'web-vitals';

const sendToAnalytics = (metric) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  const value = metric.name === 'CLS'
    ? Math.round(metric.value * 1000)
    : Math.round(metric.value);

  window.gtag('event', 'web_vitals', {
    event_category: 'Web Vitals',
    event_action: metric.name,
    event_value: value,
    event_label: metric.id,
    non_interaction: true,
  });
};

export const initWebVitals = () => {
  getCLS(sendToAnalytics);
  getLCP(sendToAnalytics);
  getFID(sendToAnalytics);  // FID available in web-vitals 2.x (CRA default)
};
